'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryViewer = function (_Component) {
  (0, _inherits3.default)(GalleryViewer, _Component);

  function GalleryViewer() {
    (0, _classCallCheck3.default)(this, GalleryViewer);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryViewer.__proto__ || (0, _getPrototypeOf2.default)(GalleryViewer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryViewer, [{
    key: 'setActivePhoto',
    value: function setActivePhoto(e, index) {
      e.preventDefault();
      this.props.setActiveIndex(index);
    }
  }, {
    key: 'nextPhoto',
    value: function nextPhoto(e) {
      e.preventDefault();
      this.props.setActiveIndex(this.props.activeIndex > this.props.items.length - 2 ? 0 : this.props.activeIndex + 1);
    }
  }, {
    key: 'previousPhoto',
    value: function previousPhoto(e) {
      e.preventDefault();
      this.props.setActiveIndex(this.props.activeIndex < 1 ? this.props.items.length - 1 : this.props.activeIndex - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          items = _props.items,
          onRequestClose = _props.onRequestClose,
          activeIndex = _props.activeIndex;
      // TODO: check behavior when the media type is video

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { id: 'photo-show-backdrop', style: { backgroundColor: 'rgb(0, 0, 0)', position: 'fixed', zIndex: 1063, bottom: 0, right: 0, left: 0, top: 0, opacity: '0.9' } }),
        _react2.default.createElement(
          'div',
          { id: 'photo-show-container', style: { top: '6%', left: 0, right: 0, margin: 'auto', width: '100%', height: '94%', position: 'fixed', zIndex: 1063, maxHeight: 'none' } },
          _react2.default.createElement(
            'div',
            { id: 'photo-show-carousel', tabIndex: 0 },
            _react2.default.createElement(
              'div',
              { className: 'photo-show-image-panel' },
              _react2.default.createElement(
                'div',
                { className: 'photo-show-hero-image-canvas' },
                _react2.default.createElement('img', { alt: '', id: 'photo-show-hero-image', src: items[activeIndex].mediaUrl, style: { maxHeight: '459.9px' } })
              ),
              items.length > 1 ? _react2.default.createElement(
                'div',
                { id: 'toggle-banner' },
                _react2.default.createElement(
                  'a',
                  { href: true, className: 'photo-show-previous', onClick: function onClick(e) {
                      return _this2.previousPhoto(e);
                    } },
                  _react2.default.createElement('span', { className: 'icon-prev' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'for-reader' },
                    i18n.gallery.previousPhoto
                  )
                ),
                _react2.default.createElement(
                  'a',
                  { href: true, className: 'photo-show-next', onClick: function onClick(e) {
                      return _this2.nextPhoto(e);
                    } },
                  _react2.default.createElement('span', { className: 'icon-next' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'for-reader' },
                    i18n.gallery.nextPhoto
                  )
                )
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { className: 'photo-show-thumbnail-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'photo-show-thumbnail-panel' },
                items.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'photo-show-thumbnail-image-wrapper' + (index === activeIndex ? ' active-thumbnail' : '') },
                    _react2.default.createElement(
                      'a',
                      { href: true, onClick: function onClick(e) {
                          return _this2.setActivePhoto(e, index);
                        } },
                      _react2.default.createElement('img', { alt: '', className: 'photo-show-thumbnail-image', src: item.mediaUrl + '?fit=inside|90:90' })
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement('span', { className: 'icon-photo-show-close', onClick: onRequestClose })
        )
      );
    }
  }]);
  return GalleryViewer;
}(_react.Component); // GalleryViewer

GalleryViewer.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired,
  onRequestClose: _react.PropTypes.func.isRequired,
  activeIndex: _react.PropTypes.number.isRequired,
  setActiveIndex: _react.PropTypes.func.isRequired
};

exports.default = GalleryViewer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryViewer.js
// module id = 1204
// module chunks = 0